import { CompactInput, PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';
import React from 'react';
import styled from 'styled-components';

const RangeInput = styled.input`
    flex: 1;
    min-width: 0;
`;

const NumberInput = styled(CompactInput)`
    width: 90px;
    flex-shrink: 0;
    flex: unset;
    text-align: center;
`;

export type PropertiesPanelRangePropertyProps = {
    id: string;
    label: React.ReactNode;
    value: number;
    min?: number;
    max?: number;
    step?: number;
    onChange?: (newValue: number, e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
};

export const PropertiesPanelRangeProperty: React.FC<PropertiesPanelRangePropertyProps> = ({ id, label, value, min, max, step, onChange, disabled }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                <RangeInput
                    id={`${id}-range`}
                    type='range'
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    disabled={disabled}
                    onChange={(e) => {
                        if (!isNaN(e.target.valueAsNumber)) {
                            onChange?.(e.target.valueAsNumber, e);
                        }
                    }}
                />
                <NumberInput
                    id={id}
                    type={'number'}
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    disabled={disabled}
                    onChange={(e) => {
                        if (!isNaN(e.target.valueAsNumber)) {
                            onChange?.(e.target.valueAsNumber, e);
                        }
                    }}
                />
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
